import * as THREE from 'three'
import { VTKLoader } from 'three/examples/jsm/loaders/VTKLoader.js'
import { TrackballControls } from 'three/addons/controls/TrackballControls.js'

const DIRECTION_POINTER_PATH = '/api/api/model/20250326_132805/James.vtk'
const MAX_PIXEL_RATIO = 2

const loader = new VTKLoader()

let pointerData = {
    camera: null,
    scene: null,
    controls: null,
    renderer: null,
    modelMesh: null,
}

function getCameraDistance() {
    const w = window.innerWidth
    const h = window.innerHeight
    return w >= 1100 && h >= 900 ? -3000 : -2400
}

export async function directionPointerLoad() {
    return new Promise((resolve) => {
        loader.load(DIRECTION_POINTER_PATH, (geometry) => {
            const material = new THREE.MeshPhongMaterial({
                side: THREE.DoubleSide,
                color: 'rgb(0,255,0)',
                specular: 0x0,
                shininess: 15,
                alphaTest: 0.1,
                transparent: false,
            })
            geometry.computeVertexNormals()
            const mesh = new THREE.Mesh(geometry, material)
            pointerData.modelMesh = mesh
            resolve(centerModel(mesh))
        })
    })
}

export function directionPointerInit(modelGroup) {
    const container = document.getElementById('directionPointer')
    document.getElementById('webgl').appendChild(container)

    const camera = new THREE.PerspectiveCamera(
        75, container.clientWidth / container.clientHeight, 0.01, 1e10
    )
    camera.position.y = getCameraDistance()
    camera.up.set(0, 0, 1)
    pointerData.camera = camera

    const scene = new THREE.Scene()
    scene.updateMatrixWorld(true)
    scene.add(camera)

    scene.add(new THREE.AmbientLight(0xffffff, 0.4))
    const dirLight = new THREE.PointLight(0xffffff, 0.7)
    dirLight.shadow.mapSize.set(256, 256)
    camera.add(dirLight)

    const renderer = new THREE.WebGLRenderer({ alpha: true })
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, MAX_PIXEL_RATIO))
    renderer.setSize(container.clientWidth, container.clientHeight)
    container.appendChild(renderer.domElement)

    scene.add(modelGroup)
    pointerData.scene = scene
    pointerData.renderer = renderer

    const controls = new TrackballControls(camera, document.getElementById('webgl'))
    controls.noZoom = true
    controls.noPan = true
    controls.target.set(0, 0, 0)
    controls.minDistance = 10
    controls.maxDistance = 500
    controls.dynamicDampingFactor = 0.3
    controls.rotateSpeed = 4
    controls.staticMoving = true
    controls.enableDamping = true
    pointerData.controls = controls
}

export function renderPointer() {
    if (pointerData.renderer && pointerData.scene && pointerData.camera) {
        pointerData.controls.update()
        pointerData.renderer.render(pointerData.scene, pointerData.camera)
    }
}

function centerModel(parentObject) {
    parentObject.updateMatrixWorld()
    const group = new THREE.Group()
    const box = new THREE.Box3().setFromObject(parentObject)
    const center = new THREE.Vector3()
    box.getCenter(center)
    parentObject.position.sub(center)
    group.add(parentObject)
    group.position.copy(center.add(parentObject.position))
    group.rotation.x = Math.PI / 2
    return group
}

export function getPointerData() {
    return pointerData
}

export function resetPointer() {
    pointerData.controls && pointerData.controls.reset()
    if (pointerData.camera) {
        pointerData.camera.up.set(0, 0, 1)
        pointerData.camera.lookAt(0, 0, 0)
    }
    if (pointerData.modelMesh && pointerData.modelMesh.parent) {
        pointerData.modelMesh.parent.rotation.set(0, Math.PI / 2, 0)
    }
}
